import axios from 'axios';
import Stories from '../../components/local/success-stories/SuccessStories';
import BackToTop from '../../components/shared/button/BackToTop';
import SiteHeader from '../../components/shared/SiteHeader';

import { getStrapiURL } from '../../lib/api';
import { useEffect } from 'react';
import { useDispatch } from '@globalStore/storeProvider';
import { sourceType } from '@components/shared/widgets/ContactUs';
import SuccessStoriesHero from '@components/local/success-stories/Hero/SuccessStoriesHero';
import StudentTestimonials from '@components/local/placement-statistics/student-testimonials/StudentTestimonials';
import StudentTestimonialsCard from '@components/local/placement-statistics/student-testimonials/StudentTestimonialsCard';
import EnquirySection from '@components/local/placement-statistics/EnquirySection';

const SuccessStories = ({ videoTestimonials, textTestimonials, count, seo }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      const isPopupViewed = sessionStorage.getItem('popup_viewed');
      if (!isPopupViewed) {
        dispatch({ type: 'SET_WIDGET_SOURCE', payload: sourceType.placement_report_popup });
      }
    }, 10000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const DownloadPlacementReport = ({ style = '' }) => {
    return (
      <button
        onClick={() =>
          dispatch({ type: 'SET_WIDGET_SOURCE', payload: sourceType.placement_report })
        }
        className={`center z-10 bg-white text-[14px] text-black md:text-sm ${style}`}
      >
        Download Placement Report
      </button>
    );
  };

  return (
    <>
      <SiteHeader
        title={'Read inspiring Success Stories From AlmaBetter Students'}
        desc={
          'Read inspiring success stories from real people. Our students’ testimonials will motivate and show you what is possible with hard work and dedication.'
        }
        url={'/success-stories'}
        image={seo?.image?.data?.attributes?.url}
      />
      <SuccessStoriesHero DownloadPlacementReport={DownloadPlacementReport} />
      <div className="container-default-1209px !px-0">
        <BackToTop />
        {videoTestimonials?.length > 0 || textTestimonials.length > 0 ? (
          <Stories
            textTestimonials={textTestimonials}
            videoTestimonials={videoTestimonials}
            count={count}
          />
        ) : (
          <div className="flex items-center justify-center p-20">No success stories</div>
        )}
      </div>
      <StudentTestimonials textTestimonials={textTestimonials} totalTextTestimonial={count?.text} />
      <EnquirySection />
    </>
  );
};

export default SuccessStories;

export const getStaticProps = async () => {
  const apiBaseUrl = getStrapiURL();
  try {
    const { data: textTestimonials } = await axios.get(
      `${apiBaseUrl}/api/testimonials?filters[videoLink][$null]=true&filters[rank][$notNull]=true&populate=cardImage&populate=avatar&populate=companyLogo&sort[0]=publishedAt:desc`
    );

    const { data: videoTestimonials } = await axios.get(
      `${apiBaseUrl}/api/testimonials?filters[videoLink][$notNull]=true&filters[rank][$notNull]=true&populate=cardImage&populate=avatar&populate=companyLogo&sort[0]=publishedAt:desc`
    );

    const { data: seoData } = await axios.get(`${apiBaseUrl}/api/global?populate=seo.image`);
    const totalTextTestimonial = textTestimonials.meta.pagination.total;
    const totalVideoTestimonial = videoTestimonials.meta.pagination.total;
    const count = { text: totalTextTestimonial, video: totalVideoTestimonial };
    return {
      props: {
        videoTestimonials:
          videoTestimonials?.data?.sort(
            (a, b) => (a.attributes.rank ?? Infinity) - (b.attributes.rank ?? Infinity)
          ) || [],
        textTestimonials:
          textTestimonials?.data?.sort(
            (a, b) => (a.attributes.rank ?? Infinity) - (b.attributes.rank ?? Infinity)
          ) || [],
        count,
        seo: seoData.data.attributes.seo,
      },
      revalidate: 3600,
    };
  } catch (error) {
    return { notFound: true };
  }
};
